import React from "react";
import PageHeader from "../../components/organisms/PageHeader";
import food1 from "../../assets/images/food1.jpg"
import food2 from "../../assets/images/food2.jpg"
import food3 from "../../assets/images/food3.jpg"
import food4 from "../../assets/images/food4.jpg"
import LeftSection from "../../components/organisms/LeftSection";
import RightSection from "../../components/organisms/RightSection";
import styled from "styled-components";
import {device} from "../../assets/styles/media";

const OperatingTime = styled.p`
    display: block;
    margin-top: 12px;
    font-size: 18px;
    color: #946626;
    ${device.mobile} {
        font-size: 14px;
        font-weight: 400;
    }
`;

const TextBox = styled.div`
    color: #4a4a4a;
    font-size: 18px;
    line-height: 1.56;
    letter-spacing: -0.4px;
    
`;
const InfoList = styled.ul`
    margin-top: 10px;
    color: #ed8e0c;
    ${device.tablet} {
        word-break: keep-all;
    }
`;
const InfoList2 = styled.ul`
    display: block;
    color: #444;
    line-height: 23px;
    letter-spacing: -0.4px;
    margin-top: 15px;

`;
const Item = styled.li`
    line-height: 1.56;
    font-size: 14px;
     ${device.tablet} {
         font-size: 17px;
     }
    ${device.mobile} {
        font-size: 14px;
    }
`;
const Item2 = styled(Item)`
    font-size: 18px;
    ${device.tablet} {
        font-size: 17px;
        line-height: 2;
    }
    ${device.mobile} {
        font-size: 14px;
        line-height: 1.56;
    }
`;

const ListItem = styled.li`
    margin-bottom: 5px;
    list-style: none;

    ${device.tablet} {
        font-size: 17px;
    }
    
    ${device.mobile} {
        font-size: 17px;
    }
`;

const Label = styled.div`
    float: left;
    color: #444;
    text-align: left;
    width: 70px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    span:first-child{
       font-weight: 600;
    }
    span:last-child {
        display: inline-block;
        width: 1px;
        height: 14px;
        margin: 0 10px 0 0;
        background: #777;
    }
    ${device.tablet} {
     span{
         font-size: 17px;
     }  
    }
    ${device.mobile} {
        width: 63px;
        span:first-child{
            font-weight: 500;
            font-size: 13px;
        }
        font-size: 13px !important;
    }
`;

const Content = styled.div`
    overflow: hidden;
    letter-spacing: -0.7px;
    color: #444;
    font-size: 15px;
    width: 390px;
    white-space: pre-wrap;
    ${device.tablet} {
        width: 90%;
    }
    ${device.mobile} {
        white-space: pre-wrap;
        font-size: 13px;
        max-width: 100vw;
        width: 80%;
        letter-spacing: -1px;
    }
`;

const YellowFont = styled.span`
    color: #ed8e0c;
    margin-left: 2px;

    ${device.mobile} {
        font-size: 13px;
        letter-spacing: -0.8px;
    }
`;
const CafeDesc = styled.div`
    ${device.mobile} {
        font-size: 13px;
        letter-spacing: -0.8px;
    }
    
`;
const NoneColor =styled.span`
color: transparent;
${device.mobile} {
    color: inherit;
}
`;


const FoodCourt = () => {
    const textList = ['자연을 벗삼은 공간에 신선하고\n건강한 별미들이 준비되어 있습니다.'];
    const list1 = ['네이처 푸드테라스는 반려견 동반 식당으로', '네이처풀 복합문화 센터 1층에 위치해 있습니다.']
    const list2 = ['카페, 가을은 내부 정비로 인해 당분간 운영하지 않습니다.', '호주 멜버른에서 유명한 스페셜티 커피 로스팅 회사의 DukesCoffee 원두를 사용합니다.']
    const textList2 = ['맛있는 음료와 달콤한 디저트가 일상에서의 지친 마음을 다독입니다.\n흐르는 시간마저 소중하게 느껴질 때 잠시 쉬어가는 건 어떨까요?'];
    const cafeInfoData = [
        {
            label: "종류",
            contents: ["커피류 / 에이드류 / 스무디류 / 허브티류"],
        },
        {
            label: "위치",
            contents: [
                <>
                    박물관 2층<YellowFont>(카페, 봄)</YellowFont> 네이처풀내
                    <YellowFont>(카페, 여름)</YellowFont>  산책로 내
                    <YellowFont>(카페, 가을)</YellowFont>  운동장 앞
                    <YellowFont>(강아지 카페, 겨울)</YellowFont>
                </>,
            ],
        },
        {
            label: "운영시간",
            contents: [
                <CafeDesc>
                    {/*카페, 봄 : 14:00 ~ 18:00 | 주말/공휴일 11:30 ~ 18:00<MobileBr/> <YellowFont>(주문 마감 : 17:30)</YellowFont><br/>*/}
                    카페, 봄 : 내부 수리로 인한 미운영<br/>
                    카페, 여름 : 10:00 ~ 17:00<YellowFont>(주문 마감 : 17:00)</YellowFont> _네이처풀 미드시즌<br/>
                    <NoneColor>카페, 여름 :</NoneColor> 10:00 ~ 20:30<YellowFont>(주문 마감 : 20:00)</YellowFont> _네이처풀 하이시즌<br/>
                    강아지 카페, 겨울 : 10:00 ~ 18:00 <YellowFont>(주문 마감: 17:30)</YellowFont>
                </CafeDesc>,
            ],
        },
    ];

    return (
        <>
            <PageHeader
                bTitle="관람"
                detail="먹거리"
                desc="강아지숲 먹거리를 안내해 드립니다."
            />

            {/*section 1*/}
            <LeftSection
                title="네이처 푸드테라스"
                enTitle="Nature Food Terrace"
                subTitle="계절을 담은 맛있는 별미가 가득합니다."
                textList={textList}
                content={<>
                    <TextBox>
                        <InfoList>
                            {list1.map((item, index) => (<Item2 key={index}>{item}</Item2>))}
                        </InfoList>
                    </TextBox>
                    <OperatingTime>(미드시즌) 운영시간 : 10:00 ~ 18:00(주문 마감: 17:00)</OperatingTime>
                    <OperatingTime>(하이시즌) 운영시간 : 11:00 ~ 20:00(주문 마감: 19:30)</OperatingTime>
                </>}
                img1={food1}
                img2={food2}
            />


            {/*section 2*/}
            <RightSection
                title="카페, 봄 여름 가을 겨울"
                enTitle="Café,Spring/Summer/Autumn/Winter"
                subTitle="시간이 머무는 카페입니다."
                textList={textList2}
                content={<>
                    <InfoList>
                        {cafeInfoData.map((item, idx) => (
                            <ListItem key={idx}>
                                <Label><span>{item.label}</span><span></span></Label>
                                {item.contents.map((content, cIdx) => (
                                    <Content key={cIdx}>{content}</Content>
                                ))}
                            </ListItem>
                        ))}
                    </InfoList>
                    <TextBox>
                        <InfoList2>
                            {list2.map((item, index) => (<Item key={index}>{item}</Item>))}
                        </InfoList2>
                    </TextBox>
                </>}
                img1={food3}
                img2={food4}
            />

        </>
    );
};

export default FoodCourt;
